<template>
     <div class="version1-right-middle">
        <Header title="专利奖"></Header>
        <Bar :options="options"  @echartClick="echartClick"></Bar>
    </div>
</template>
<script>
import Header from './header.vue'
import Bar from '@/components/echarts/Pie'
import BaseMixin from '@/views/_mixin'
import {rewardRange} from '@/api/databaseBin'
export default {
  mixins: [BaseMixin],
  data() {
    return {
      options: {},
      xData: [
        {name: 'public', label: '公开', count: 0},
        {name: 'examination', label: '实审', count: 0},
        {name: 'authorization', label: '授权', count: 0},
        {name: 'turndown', label: '驳回', count: 0},
        {name: 'withdraw', label: '撤回', count: 0},
        {name: 'total', label: '总量', count: 0}
      ],
      xDatas: [],
      seriesDataOne: [],
      seriesDataTwo: [],
      barData: []
    }
  },
  components: {
    Header,
    Bar
  },
  mounted() {
    this.getLegal()
  },
  methods: {
    echartClick(params) {
      let name = params.name
      if (name === '实审') {
        name = '实质审查'
      }
      let str = `奖励等级=(${name})`
      if (name === '总量') {
        str = '专利类型=(发明申请 or 实用新型 or 外观设计)'
      }
      this.jumpIpi(str, 'isMerge', 'publicOrder')
    },
    async getLegal() {
      // legalRange().then(res => {
      //   if (res[this.codeMapping]) {
      //     res[this.dataMapping].forEach(ele => {
      //       this.xData.forEach(item => {
      //         if (item.name === ele.name) {
      //           this.seriesDataTwo.push(ele.count)
      //           this.seriesDataOne.push(0)
      //           this.xDatas.push(item.label)
      //         }
      //       })
      //     })
      //     this.barEcharts()
      //     for (let i = 1; i < this.seriesDataTwo.length - 1; i++) {
      //       //
      //       for (let j = 0; j < i; j++) {
      //         this.seriesDataOne[i] += this.seriesDataTwo[j]
      //       }
      //     }
      //   }
      // })
      const res = await rewardRange()
      let newArr = []
      res.data.forEach(item => {
        newArr.unshift(item)
      })
      this.barData = newArr
      this.barEcharts()
    },
    barEcharts() {
      var salvProName = this.barData.map(item => item.name)
      var salvProValue = this.barData.map(item => item.count)
      var salvProMax = []
      for (let i = 0; i < salvProValue.length; i++) {
        salvProMax.push(salvProValue[0])
      }
      // 颜色渐变
      const gradList = new this.$echarts.graphic.LinearGradient(0, 0, 1, 0, [
        {
          offset: 0,
          color: 'rgb(0, 113, 252)'
        },
        {
          offset: 1,
          color: 'rgb(75, 226, 236)'
        }
      ])
      this.options = {
        grid: {
          left: '5%',
          right: '5%',
          bottom: '2%',
          top: '5%',
          containLabel: true
        },
        tooltip: {
          trigger: 'axis',
          formatter: function (params) {
            return params[0].name + ' : ' + params[0].value
          }
        },
        xAxis: {
          type: 'value',
          splitLine: {
            show: false,
            lineStyle: {
              color: '#ccc'
            }
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            show: false,
            color: '#fff'
          }
        },
        yAxis: [
          {
            type: 'category',
            axisLabel: {
              show: true,
              textStyle: {
                color: '#fff'
              }
            },
            splitLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: '#ccc'
              }
            },
            data: salvProName
          }
        ],
        series: [
          {
            name: '',
            type: 'bar',
            label: {
              show: true,
              position: 'right',
              color: '#fff'
            },
            itemStyle: {
              normal: {
                barBorderRadius: [0, 30, 30, 0],
                color: gradList
              }
            },
            barWidth: 14,
            data: salvProValue
          }
        ]
      }
    }
  }
}
</script>
